<template>
    <div class="modal fade" id="confirmCampaignName" tabindex="-1" role="dialog" aria-labelledby="confirmCampaignNameGroup" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Campaign Name Confirmation</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>"{{ campaignName }}" is already used for some other campaign, Are you sure, you want to save?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" @click="saveCampaign" class="btn btn-primary" data-dismiss="modal">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'AddCampaignNameConfirmModal',
    data() {
        return {

        }
    },
    props: {
        campaignName: {
            type: String
        }
    },
    methods: {
        saveCampaign() {
            this.$emit('saveCampaign')
        },
    },
}
</script>

<style lang="scss">

</style>
